export const terActs0 = [
  {
    level: 0,
    levelName: "Autoconhecimento",
    type: "lesson",
    title: "Introdução à Jornada",
    slug: "journey-introduction",
  },
  {
    level: 0,
    levelName: "Autoconhecimento",
    type: "lesson",
    title: "Descobrindo sua personalidade",
    slug: "discovering-your-personality",
  },
  {
    level: 0,
    levelName: "Autoconhecimento",
    type: "lesson",
    title: "Temperamento e Caráter",
    slug: "temperament-and-character",
  },
  {
    level: 0,
    levelName: "Autoconhecimento",
    type: "lesson",
    title: "Conhecendo seu Estilo Pessoal",
    slug: "knowing-your-personal-style",
  },
  {
    level: 0,
    levelName: "Autoconhecimento",
    type: "lesson",
    title: "Valores & Tendências",
    slug: "values-and-trends",
  },
  {
    level: 0,
    levelName: "Autoconhecimento",
    type: "lesson",
    title: "Montando sua Jornada Pessoal",
    slug: "building-your-personal-journey",
  },
];

export const terActs1 = [
  {
    level: 1,
    levelName: "Consciência do Sofrimento",
    type: "lesson",
    title: "Eixo do sofrimento",
    slug: "suffering-axis",
  },
  {
    level: 1,
    levelName: "Consciência do Sofrimento",
    type: "lesson",
    title: "Dor limpa e dor suja",
    slug: "clean-pain-and-dirty-pain",
  },
  {
    level: 1,
    levelName: "Consciência do Sofrimento",
    type: "lesson",
    title: "Histórias que a mente conta",
    slug: "stories-the-mind-tells",
  },
  {
    level: 1,
    levelName: "Consciência do Sofrimento",
    type: "lesson",
    title: "Como fazemos escolhas",
    slug: "how-we-make-choices",
  },
  {
    level: 2,
    levelName: "Aceitação e Disposição",
    type: "lesson",
    title: "Aceitação das emoções e disposição",
    slug: "suffering-axis2",
  },
  {
    level: 2,
    levelName: "Aceitação e Disposição",
    type: "lesson",
    title: "O papel das emoções",
    slug: "suffering-axis3",
  },
  {
    level: 2,
    levelName: "Aceitação e Disposição",
    type: "lesson",
    title: "A ação vem antes da motivação",
    slug: "suffering-axis4",
  },
  {
    level: 2,
    levelName: "Aceitação e Disposição",
    type: "lesson",
    title: "Desesperança criativa",
    slug: "suffering-axis5",
  },
  {
    level: 3,
    levelName: "Centrando-se",
    type: "lesson",
    title: "Você não é seus pensamentos",
    slug: "suffering-axis6",
  },
  {
    level: 3,
    levelName: "Centrando-se",
    type: "lesson",
    title: "O eu que escolhe",
    slug: "suffering-axis7",
  },
  {
    level: 3,
    levelName: "Centrando-se",
    type: "lesson",
    title: "Autoconceito e observação do eu-antes-lá",
    slug: "suffering-axis8",
  },
  {
    level: 3,
    levelName: "Centrando-se",
    type: "lesson",
    title: "Flexibilidade psicológica no dia a dia",
    slug: "suffering-axis9",
  },
  {
    level: 4,
    levelName: "Alinhamento com Valores",
    type: "lesson",
    title: "Identificando o que importa pra mim",
    slug: "suffering-axis10",
  },
  {
    level: 4,
    levelName: "Alinhamento com Valores",
    type: "lesson",
    title: "Ação comprometida",
    slug: "suffering-axis11",
  },
  {
    level: 4,
    levelName: "Alinhamento com Valores",
    type: "lesson",
    title: "Pequenos passos com intenção",
    slug: "suffering-axis12",
  },
  {
    level: 4,
    levelName: "Alinhamento com Valores",
    type: "lesson",
    title: "Viver com propósito, não com perfeição",
    slug: "suffering-axis13",
  },
  {
    level: 5,
    levelName: "Sustentação e Retorno após Quedas",
    type: "lesson",
    title: "Como lidar com recaídas",
    slug: "suffering-axis14",
  },
  {
    level: 5,
    levelName: "Sustentação e Retorno após Quedas",
    type: "lesson",
    title: "Lapsos e recaídas",
    slug: "suffering-axis15",
  },
  {
    level: 5,
    levelName: "Sustentação e Retorno após Quedas",
    type: "lesson",
    title: "Planejamento de apoios para momentos difíceis",
    slug: "suffering-axis16",
  },
  {
    level: 5,
    levelName: "Sustentação e Retorno após Quedas",
    type: "lesson",
    title: "Ciclos de vida e novos inícios",
    slug: "suffering-axis17x",
  },
];
